module.exports = __webpack_public_path__ + "static/media/rochdale-logo.4d1135a5.png";